import React, {
  createContext,
  useContext,
  useMemo,
  type ReactNode,
} from 'react'
import {
  PostHogService,
  type TrackingService,
} from '../services/tracking.service'

const TrackingContext = createContext<TrackingService | undefined>(undefined)

export interface TrackingProviderProps {
  children: ReactNode
}

export const TrackingProvider: React.FC<TrackingProviderProps> = ({
  children,
}) => {
  const service: TrackingService = useMemo(() => new PostHogService(), [])

  return (
    <TrackingContext.Provider value={service}>
      {children}
    </TrackingContext.Provider>
  )
}

export function useTracking(): TrackingService {
  const context = useContext(TrackingContext)
  if (!context) {
    throw new Error('useTracking must be used within a TrackingProvider')
  }
  return context
}
